import { Show } from "solid-js";

export const CloseButton = (props) => {
  const onClickHandler = props.onClickHandler;

  return (
    <button 
      class={`font-bold uppercase ${props.className != undefined ? props.className : ''}`}
      classList={props.classList}
      onClick={onClickHandler != undefined ? onClickHandler : null}
    >
      <Show
        when={props.children}
        fallback={(<span><svg aria-label="Close Icon" xmlns="http://www.w3.org/2000/svg" class="inline-block" height="32" viewBox="0 -960 960 960" width="32"><path fill="currentColor" d="m248.667-188.667-58.667-60L421-480 190-712.667l58.667-59.999L481-540l230.333-232.666L770-712.667 539.666-480 770-248.667l-58.667 60L481-421.334 248.667-188.667Z"/></svg></span>)}
      >
        {props.children}
      </Show>
    </button>
  )
}